import { render, staticRenderFns } from "./previewTextConent.vue?vue&type=template&id=37445268&scoped=true"
import script from "./previewTextConent.vue?vue&type=script&lang=js"
export * from "./previewTextConent.vue?vue&type=script&lang=js"
import style0 from "./previewTextConent.vue?vue&type=style&index=0&id=37445268&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37445268",
  null
  
)

export default component.exports